"use strict";
/* Autogenerated file. Do not edit manually. */

/* tslint:disable */

/* eslint-disable */

var _classCallCheck = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IERC165__factory = void 0;

var ethers_1 = require("ethers");

var IERC165__factory = /*#__PURE__*/function () {
  function IERC165__factory() {
    _classCallCheck(this, IERC165__factory);
  }

  _createClass(IERC165__factory, null, [{
    key: "connect",
    value: function connect(address, signerOrProvider) {
      return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
  }]);

  return IERC165__factory;
}();

exports.IERC165__factory = IERC165__factory;
var _abi = [{
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];